export default __webpack_public_path__ + "assets/process-3.a8db2b89.png";